import React, { useRef, useEffect } from "react"

export default ({ buttonText }) => {
	
	return (
		<>
			<section className={ "u-container u-section-spacing u-center-text u-container--medium"}>
				<button onClick={ e => { window.Cookiebot.renew() }}>{ buttonText }</button>
			</section>
		</>
	)

}